import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ImageIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ImageIconPath";
import SpeechBubbleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/SpeechBubbleIconPath";
import PaperclipIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PaperclipIconPath";
import styles from "./Indicators.module.css";

type IndicatorsProps = {
  hasFile?: boolean;
  hasImage?: boolean;
  hasComment?: boolean;
};

function Indicators({
  hasComment = false,
  hasImage = false,
  hasFile = false,
}: IndicatorsProps) {
  return (
    <div data-testid="indicators" className={styles["root"]}>
      {hasFile && (
        <div className={styles["icon"]} data-testid="has-file">
          <FixaSSRIcon paths={PaperclipIconPath} />
        </div>
      )}
      {hasImage && (
        <div className={styles["icon"]} data-testid="has-image">
          <FixaSSRIcon paths={ImageIconPath} />
        </div>
      )}
      {hasComment && (
        <div className={styles["icon"]} data-testid="has-comment">
          <FixaSSRIcon paths={SpeechBubbleIconPath} />
        </div>
      )}
    </div>
  );
}

export default Indicators;
